import { Navigate, useNavigate, useParams } from 'react-router';
import { DeviceCard } from '@/features/settings/components/device-card';
import { SyncStatusCard } from '@/features/sync-status/components/sync-status-card';
import { TrashList } from '@/features/trash/components/trash-list';
import { Page } from '@/shared/components/page/page';
import { PageHeader } from '@/shared/components/page/page-header';
import { useTranslation } from '@/shared/i18n/use-translation';
import { Tabs } from '@/shared/ui/tabs/tabs';
import { TabsList } from '@/shared/ui/tabs/tabs-list';
import { TabsTrigger } from '@/shared/ui/tabs/tabs-trigger';
import { DATA_TABS } from './data-tabs';

/** This device's copy of the kit: how it syncs, what it stores, and what was deleted. */
export function DataPage() {
  const { t } = useTranslation();
  const { tab } = useParams();
  const navigate = useNavigate();
  const current = DATA_TABS.find((entry) => entry.value === tab);
  if (!current) return <Navigate to="/data/sync" replace />;
  return (
    <Page className="max-w-3xl">
      <PageHeader title={t('Data')} description={t('Sync, storage on this device and the trash.')} />
      <Tabs value={current.value} onValueChange={(value) => navigate(`/data/${value}`)}>
        <TabsList>
          {DATA_TABS.map(({ value, label, icon: Icon }) => (
            <TabsTrigger key={value} value={value}>
              <Icon /> {t(label)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      {current.value === 'sync' && <SyncStatusCard />}
      {current.value === 'storage' && <DeviceCard />}
      {current.value === 'trash' && <TrashList />}
    </Page>
  );
}
